module.exports = __webpack_public_path__ + "static/media/cashrich.238cdeea.webp";